<dv-dialog-content>
  <dv-dynamic-form
    [elements]="timeElements | translateElements"
    [formGroup]="timeFormGroup">
  </dv-dynamic-form>
  <dv-dynamic-form
    [elements]="weekdaysElements | translateElements"
    [formGroup]="weekdaysFormGroup">
  </dv-dynamic-form>
  <dv-button footer-right (click)="cancel()">
    {{ 'General.Cancel' | translate }}
  </dv-button>
  <dv-button
    footer-right
    color="secondary"
    (click)="performSave()"
    [disabled]="
      !(
        timeFormGroup.valid &&
        weekdaysFormGroup.valid &&
        (timeFormGroup.dirty || weekdaysFormGroup.dirty)
      )
    ">
    {{ 'General.Save' | translate }}
  </dv-button>
</dv-dialog-content>
